import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GroupsOfGroup, GroupsService, UsersService } from '@rocksoft/security-sdk';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import { GroupApiActions, GroupsOfGroupResolverActions } from './groups-of-group.actions';

@Injectable()
export class GroupsOfGroupEffects {
  private readonly userService = inject(UsersService);
  private readonly groupService = inject(GroupsService);
  private readonly actions$ = inject(Actions);

  groupsOfGroupLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GroupsOfGroupResolverActions.userGroupsRequested),
      mergeMap(({ groupId }) =>
        safeMap(
          this.groupService.getGroupsOfGroup({ id: groupId }),
          (groups: GroupsOfGroup[]) => GroupApiActions.userGroupsLoaded({ groups }),
          (error) => GroupApiActions.userGroupsLoadedError({ error })
        )
      )
    );
  });
}
